import { render, staticRenderFns } from "./UserProfileChallengerLifeStats.vue?vue&type=template&id=43223cd7&scoped=true&"
import script from "./UserProfileChallengerLifeStats.vue?vue&type=script&lang=ts&"
export * from "./UserProfileChallengerLifeStats.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43223cd7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VImg } from 'vuetify/lib/components/VImg';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAvatar } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
installComponents(component, {VCard,VCardTitle,VImg,VListItem,VListItemAvatar,VListItemContent,VListItemSubtitle})
